
import React, { useEffect, useState } from "react";
import Footer from "../Footer";

import "../../css/BangGiaChup.css";
import Img15 from "../../assets/Service/BangGiaChup-banner.jpg";
import Img16 from "../../assets/Service/BangGiaChup-left.jpg";
import Img17 from "../../assets/Service/BangGiaChup-right.jpg"

const JSON_URL =
    "https://raw.githubusercontent.com/VuongMinh01/MinMedia-anh/main/BangGia/BangGiaChup.json";

const localImages = {
    truyenThong: Img15,
    phongSu: Img16,
    right: Img17,

};

function formatPrice(price) {
    return `${new Intl.NumberFormat("vi-VN").format(price)} VND`;
}

export default function Picture() {
    const [data, setData] = useState(null);
    const [error, setError] = useState("");
    const [retry, setRetry] = useState(0);

    useEffect(() => {
        const controller = new AbortController();

        async function loadData() {
            try {
                setError("");

                const response = await fetch(JSON_URL, {
                    signal: controller.signal,
                    cache: "no-store"
                });

                if (!response.ok) {
                    throw new Error(
                        `Không thể tải bảng giá từ GitHub (HTTP ${response.status}).`
                    );
                }

                const text = await response.text();

                if (!text.trim()) {
                    throw new Error(
                        "File BangGiaPicture.json đang trống. Hãy thêm dữ liệu và Commit changes."
                    );
                }

                let result;

                try {
                    result = JSON.parse(text);
                } catch {
                    throw new Error(
                        "Dữ liệu JSON không hợp lệ. Hãy kiểm tra dấu ngoặc và dấu phẩy."
                    );
                }

                if (
                    !result.page ||
                    !Array.isArray(result.packages) ||
                    !result.gallery
                ) {
                    throw new Error(
                        "JSON cần có các trường page, packages và gallery."
                    );
                }

                setData(result);
            } catch (err) {
                if (err.name !== "AbortError") {
                    setError(err.message || "Đã xảy ra lỗi khi tải dữ liệu.");
                }
            }
        }

        loadData();

        return () => controller.abort();
    }, [retry]);

    return (
        <>

            <main className="picture-page">
                {error ? (
                    <section className="picture-status">
                        <span className="picture-eyebrow">
                            MinMin Wedding - Phóng Sự Cưới
                        </span>

                        <h1>Chưa thể tải bảng giá</h1>
                        <p>{error}</p>

                        <button
                            type="button"
                            className="picture-button"
                            onClick={() => setRetry((value) => value + 1)}
                        >
                            Thử tải lại ↗
                        </button>
                    </section>
                ) : !data ? (
                    <section className="picture-status">
                        <span className="picture-loader" />
                        <p>Đang tải bảng giá MinMin Wedding - Phóng Sự Cưới...</p>
                    </section>
                ) : (
                    <>
                        <section className="picture-hero">
                            <div className="picture-container picture-hero-grid">
                                <div className="picture-hero-copy">
                                    <span className="picture-eyebrow">
                                        {data.page.eyebrow}
                                    </span>

                                    <h1>{data.page.title}</h1>

                                    <p>{data.page.description}</p>

                                    <a className="picture-button" href="#picture-prices">
                                        Khám phá bảng giá <span>↘</span>
                                    </a>

                                    <div className="picture-hero-note">
                                        <span className="picture-note-line" />
                                        <span>YOUR STORY, OUR FRAME</span>
                                    </div>
                                </div>

                                <div className="picture-hero-visual">
                                    <img
                                        src={Img15}
                                        alt="Ảnh chụp truyền thống trong ngày cưới"
                                    />

                                    <div className="picture-image-caption">
                                        <span>MinMin Wedding - Phóng Sự Cưới</span>
                                        <span>01 / WEDDING</span>
                                    </div>

                                    <span className="picture-hero-number"></span>
                                </div>
                            </div>
                        </section>

                        <section
                            className="picture-prices"
                            id="picture-prices"
                        >
                            <div className="picture-container">
                                <div className="picture-section-heading">
                                    <div>
                                        <span className="picture-eyebrow">
                                            OUR SERVICES
                                        </span>

                                        <h2>{data.page.sectionTitle}</h2>

                                        <p>{data.page.sectionDescription}</p>
                                    </div>

                                    <span className="picture-section-index">
                                        01 — 02
                                    </span>
                                </div>

                                <div className="picture-package-grid">
                                    {data.packages.map((item) => (
                                        <article
                                            className="picture-package"
                                            key={item.id}
                                        >
                                            <div className="picture-package-top">
                                                <span className="picture-package-number">
                                                    {item.number}
                                                </span>

                                                <span className="picture-package-mark">
                                                    MINMIN WEDDING / PHOTO
                                                </span>
                                            </div>

                                            <h3>{item.name}</h3>

                                            <p className="picture-package-subtitle">
                                                {item.subtitle}
                                            </p>

                                            <div className="picture-package-divider" />

                                            <ul className="picture-price-list">
                                                {item.items.map((service, index) => (
                                                    <li
                                                        className="picture-price-item"
                                                        key={`${item.id}-${index}`}
                                                    >
                                                        <span className="picture-price-name">
                                                            {service.name}
                                                        </span>

                                                        <strong className="picture-price-value">
                                                            {formatPrice(service.price)}
                                                        </strong>
                                                    </li>
                                                ))}
                                            </ul>

                                            <div className="picture-package-footer">
                                                <span className="picture-check">✓</span>
                                                <span>{item.completion}</span>
                                            </div>
                                        </article>
                                    ))}
                                </div>
                            </div>
                        </section>

                        <section className="picture-gallery">
                            <div className="picture-container">
                                <div className="picture-gallery-heading">
                                    <div>
                                        <span className="picture-eyebrow">
                                            MOMENTS THAT MATTER
                                        </span>

                                        <h2>{data.gallery.title}</h2>

                                        <p>{data.gallery.description}</p>
                                    </div>
                                </div>

                                <div className="picture-gallery-grid">
                                    {data.packages.map((item) => {
                                        const image = localImages[item.image];

                                        if (!image) return null;

                                        return (
                                            <figure
                                                className="picture-gallery-item"
                                                key={item.id}
                                            >
                                                <img
                                                    src={image}
                                                    alt={item.name}
                                                    loading="lazy"
                                                />

                                                <figcaption>
                                                    <span>{item.number} / MINMIN WEDDING</span>
                                                    <strong>{item.name}</strong>
                                                </figcaption>
                                            </figure>
                                        );
                                    })}
                                </div>
                            </div>
                        </section>

                        {/* <section className="picture-contact">
                            <div className="picture-container picture-contact-inner">
                                <div>
                                    <span className="picture-eyebrow">
                                        LET’S CREATE SOMETHING BEAUTIFUL
                                    </span>

                                    <h2>Mỗi khoảnh khắc đều xứng đáng được lưu giữ.</h2>

                                    <p>
                                        Liên hệ MinMin để trao đổi về lịch chụp và gói
                                        dịch vụ phù hợp với bạn.
                                    </p>
                                </div>

                                <a className="picture-button" href="tel:">
                                    Liên hệ MinMin Wedding - Phóng Sự Cưới ↗
                                </a>
                            </div>
                        </section> */}
                    </>
                )}
            </main>

            <Footer />
        </>
    );
}
